import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import TaskAlt from '@mui/icons-material/TaskAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ProductSelectorButton = React.forwardRef(
  (
    { openProductPage, products, product, buttonProps = {}, wrapperProps = {} },
    ref,
  ) => {
    const { t } = useTranslation();
    return (
      <Box
        id="product-selector-button"
        ref={ref}
        {...wrapperProps}
        sx={{
          borderRadius: (theme) => `${theme.shape.borderRadius}px`,
          ...(wrapperProps?.sx || {}),
        }}
      >
        {products?.length > 1 && (
          <Button
            size="small"
            variant="outlined"
            onClick={openProductPage}
            startIcon={<TaskAlt fontSize="small" />}
            endIcon={<ExpandMoreIcon fontSize="10px" />}
            {...buttonProps}
            sx={{ ...buttonProps?.sx }}
          >
            {product?.name || t('product_selection_headline')}
          </Button>
        )}
        {products?.length === 1 && (
          <Grid
            container
            sx={{
              justifyContent: 'center',
              pr: 1,
              pl: 1,
            }}
          >
            <Grid item sx={{ maxWidth: '20px', mr: 0.5 }}>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  lineHeight: '100%',
                  height: '100%',
                }}
              >
                <TaskAlt
                  fontSize="inherit"
                  sx={{
                    color: 'text.secondary',
                    lineHeight: '100%',
                    height: '100%',
                    width: '100%',
                  }}
                />
              </Typography>
            </Grid>
            <Grid item xs="auto">
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                }}
              >
                {product?.name || products[0]?.name}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Box>
    );
  },
);
ProductSelectorButton.displayName = 'ProductSelectorButton';
export default ProductSelectorButton;
